const getGroupKey = retailerName => {
  const group = retailerName.trim().toUpperCase().charAt(0);

  return /[A-Z]/.test(group) ? group : '123';
};

export default getGroupKey;
